<form [formGroup]="form" class="product-attributes-tab space-y-6">
  <!-- PACKAGE TYPE — myAIS-only -->
  @if (isMyAis()) {
  <div
    class="enr-bg-surface rounded-lg shadow-sm"
    data-readiness-target="package-type"
  >
    <enr-collapsible
      class="full-height-collapsible"
      [title]="'Package Type'"
      [expanded]="true"
      [ariaLabel]="'Package Type'"
    >
      <span slot="title">Package Type</span>
      <div class="space-y-2 pt-2">
        <p class="product-attributes-tab__hint">
          Package type of this product offering.
        </p>
        <enr-select
          placeholder="Select package type"
          [options]="packageTypeOptions"
          [clearable]="true"
          formControlName="packageType"
        ></enr-select>
      </div>
    </enr-collapsible>
  </div>
  }

  <!-- NETWORK TYPE — myAIS + AI Chatbot. Required only on myAIS, mirroring
       the publish-readiness rule in flat-detail.validator.ts. -->
  @if (showNetworkType()) {
  <div
    class="enr-bg-surface rounded-lg shadow-sm"
    data-readiness-target="network-type"
  >
    <enr-collapsible
      class="full-height-collapsible"
      [title]="'Network Type'"
      [expanded]="true"
      [ariaLabel]="'Network Type'"
    >
      <span slot="title"
        >Network Type @if (isMyAis()) {
        <span class="product-attributes-tab__req" aria-hidden="true">*</span>
        }</span
      >
      <div class="space-y-2 pt-2">
        <p class="product-attributes-tab__hint">
          Network type of this product offering.
        </p>
        <enr-select
          [placeholder]="networkTypePlaceholder"
          [options]="networkTypeOptions"
          [multiple]="true"
          [searchable]="true"
          [clearable]="true"
          [disabled]="networkTypeLoading"
          formControlName="networkType"
        ></enr-select>
      </div>
    </enr-collapsible>
  </div>
  }

  <!-- SEGMENT — always shown, for every channel -->
  <div
    class="enr-bg-surface rounded-lg shadow-sm"
    data-readiness-target="segment"
  >
    <enr-collapsible
      class="full-height-collapsible"
      [title]="'Segment'"
      [expanded]="true"
      [ariaLabel]="'Segment'"
    >
      <span slot="title">Segment</span>
      <div class="space-y-2 pt-2">
        <p class="product-attributes-tab__hint">
          Customer segments this package is offered to.
        </p>
        <enr-select
          [placeholder]="segmentPlaceholder"
          [options]="segmentOptions"
          [multiple]="true"
          [searchable]="true"
          [clearable]="true"
          [disabled]="segmentLoading"
          formControlName="segment"
        ></enr-select>
      </div>
    </enr-collapsible>
  </div>

  <!-- PRODUCT EFFECTIVE OPTION — myAIS-only -->
  @if (isMyAis()) {
  <div
    class="enr-bg-surface rounded-lg shadow-sm"
    data-readiness-target="effective"
  >
    <enr-collapsible
      class="full-height-collapsible"
      [title]="'Product effective option'"
      [expanded]="true"
      [ariaLabel]="'Product effective option'"
    >
      <span slot="title"
        >Product effective option
        <span class="product-attributes-tab__req" aria-hidden="true"
          >*</span
        ></span
      >
      <div class="space-y-2 pt-2">
        <p class="product-attributes-tab__hint">
          When the package becomes effective for the customer after activation.
        </p>
        <enr-select
          placeholder="Please select"
          [options]="productEffectiveOptions()"
          [multiple]="true"
          [searchable]="true"
          [clearable]="true"
          formControlName="productEffectiveOption"
        ></enr-select>
      </div>
    </enr-collapsible>
  </div>
  }
</form>
